import {LiveTableProps} from "../../../types";
import Table, {TableColumn} from "../../../../../components/Table";
import {TableContainer} from "../../../styles";
import React, {useState} from "react";
import useGetMe from "../../../../../hooks/useCurrentUser";
import BillingPanelService from "../../service/BillingPanelService";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import {Col} from "antd";
import {Field} from "formik";
import {formatDateView, formatMoney} from "../../../../adiqEdi/detalhesEdi/utils";
import {formatProduct} from "../../../utils";
import {formatBillingType} from "../../../../../utils/generalFormat";


export const LiveTable: React.FC<LiveTableProps> = ({
  data,
  currentPage,
  pageSize,
  onPageChange,
  onPageSizeChange,
}) => {
  const user = useGetMe();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const formattedDate = (date: string) => formatDateView(date);

  return (
    <div>
      <LoadingOverlay
        show={isLoading}
        relative
      />

      <TableContainer>
        <Table
          dataSource={data.records}
          pagination = {
            {
              defaultPageSize: pageSize,
              defaultCurrent: currentPage,
              current: currentPage,
              onShowSizeChange: (_, size) => {
                onPageSizeChange(size);
              },
              total: data.count,
              onChange: (pageNum) => onPageChange(pageNum),
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} de ${total} cobranças`,
            }}
        >
          <TableColumn title="Código do Estabelecimento" dataIndex="merchantId" key="merchantId" />
          {(user.userType === 3 || user.userType === 6 || user.userType === 7) && (
            <TableColumn title="Nome Fantasia" dataIndex="nickName" key="nickName" />
          )}
          {(user.userType === 3 || user.userType === 6 || user.userType === 7) && (
            <TableColumn title="Terminal" dataIndex="terminal" key="terminal" />
          )}
          <TableColumn title="Serial Number" dataIndex="serialNumber" key="serialNumber" />
          <TableColumn title="Produto" dataIndex="product" key="product" render={formatBillingType}/>
          <TableColumn title="Data de Início da Cobrança" dataIndex="billingDate" key="billingDate" render={formattedDate}/>
          <TableColumn title="Valor" dataIndex="value" key="value" render={formatMoney}/>
        </Table>
      </TableContainer>
    </div>
  )
}

export default LiveTable;
